import { render } from "./TextView.vue?vue&type=template&id=2f875433"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__